import { render, staticRenderFns } from "./editParametro.vue?vue&type=template&id=205fc6e5&scoped=true&"
import script from "./editParametro.vue?vue&type=script&lang=js&"
export * from "./editParametro.vue?vue&type=script&lang=js&"
import style0 from "./editParametro.vue?vue&type=style&index=0&id=205fc6e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205fc6e5",
  null
  
)

export default component.exports